// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsAdd = {
  benefits_section_add: {
    contentful_name: '[DEFAULT] Benefits Section - AD&D',
    eoi_header: '可保性证明',
    eoi_body: '注册后,您可能需要回答一些关于家族病史的问题,以获得全额保障的批准。详情请查看您的计划文件。',
    dependent_coverage_header: '受抚养人保障',
    dependent_coverage_body:
      '您还可以为您的受抚养人购买意外死亡和伤残保险。这通常与您的个人保险运作方式相同,但您可以为受抚养人购买的保额可能会根据您自己的选择而有所不同。有关保险范围和费率的完整详情,请参阅您的福利文件。',
    bundled_amount: '等于您的补充人寿保险保额',
    bundled_insurance_header: '捆绑保险',
    bundled_insurance_body:
      '您的补充意外身故保障与补充人寿保险保障捆绑在一起,这意味着您每购买一美元的补充人寿保险,就会获得等额的补充意外伤害身故及伤残保险。',
    basic_benefit_amount: '基本福利金额',
    multiple_of_eligible_pay_capped: '{max}或员工合格工资的{factor}倍中的较小值',
    multiple_of_eligible_pay: '{factor}倍员工合格薪酬',
    multiple_of_salary_capped: '{max}或员工工资的{factor}倍中的较小值',
    multiple_of_salary: '{factor}倍员工工资',
    optional_benefit_amount: '可选福利金额',
    optional_bundled_amount: '等于您的可选人寿保险金额',
    optional_bundled_insurance_body:
      '您的可选意外身故保障与可选人寿保险保障捆绑在一起,这意味着您每购买一美元的可选人寿保险,就会获得等额的可选意外身故及伤残保险。',
    optional: '可选',
    supplemental_benefit_amount: '补充福利金额',
    supplemental_bundled_amount: '等于您的补充人寿保险保额',
    supplemental_bundled_insurance_body:
      '您的补充意外身故保障与补充人寿保险保障捆绑在一起,这意味着您每购买一美元的补充人寿保险,就会获得等额的补充意外伤害身故及伤残保险。',
    supplemental: '补充',
    voluntary_benefit_amount: '自愿福利金额',
    voluntary_bundled_amount: '等于您的自愿人寿保险保额',
    voluntary_bundled_insurance_body:
      '您的自愿意外身故保障与自愿人寿保险保障捆绑在一起,这意味着您每购买一美元的自愿人寿保险,就会获得等额的自愿意外身故及伤残保险。',
    voluntary: '自愿',
  },
};
